export default __webpack_public_path__ + "static/media/la_ferte-vidame05.4a70585a.jpg";